import classNames from 'classnames/bind';
import styles from './TitleComp.module.scss';

const cx = classNames.bind(styles);

function TitleComp({ children }) {
  return <h1 className={cx('title')}>{children}</h1>;
}

export default TitleComp;
